import { lt } from '@mews/framework';
import { Button, Dialog, Stack } from '@optimus-web/core';
import { useAdditionalAuthorizationStore } from './additionalAuthorizationStore';
import { useRequestActionAuthorization } from './useRequestActionAuthorization';

export const AdditionalAuthorizationModal = () => {
    const { isAdditionalAuthorizationModalOpen, closeAdditionalAuthorizationModal } = useAdditionalAuthorizationStore();
    const { mutate: requestActionAuthorization } = useRequestActionAuthorization();

    const handleClick = () => {
        requestActionAuthorization({});
        closeAdditionalAuthorizationModal();
    };

    return (
        <Dialog
            title={lt('ReverifyModalTitle')}
            active={isAdditionalAuthorizationModalOpen}
            onClose={closeAdditionalAuthorizationModal}
            size="small"
            modal
            footer={{
                primary: (
                    <Button variant="primary" onClick={handleClick} type="submit" size="medium">
                        {lt('GeneralSendLink')}
                    </Button>
                ),
            }}
        >
            <Stack vertical spacing="200">
                {lt('ReverifyModalDescription')}
            </Stack>
        </Dialog>
    );
};
